(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conversion-human-hero"] && !Shopify.designMode) return;
  try {
    
  function startHeroVideos(root) {
    root.querySelectorAll('.pgx-hero video.pgx-video').forEach((video) => {
      video.querySelectorAll('img:not([alt])').forEach((img) => img.setAttribute('alt', ''));
      if (video.dataset.autoplayInitialized) return;
      video.dataset.autoplayInitialized = 'true';
      video.muted = true;
      video.playsInline = true;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const control = video.closest('.pgx-hero')?.querySelector('.pgx-video-control');
      const setState = (playing) => {
        if (!control) return;
        control.textContent = playing ? control.dataset.pauseLabel : control.dataset.playLabel;
        control.setAttribute('aria-pressed', playing ? 'false' : 'true');
      };
      if (reduceMotion) {
        video.pause();
        setState(false);
      } else {
        video.play()?.catch(() => setState(false));
      }
      control?.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          setState(true);
        } else {
          video.pause();
          setState(false);
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => startHeroVideos(document), { once: true });
  } else {
    startHeroVideos(document);
  }
  document.addEventListener('shopify:section:load', (event) => startHeroVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgx-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var API = 'https://api.postcodes.io/postcodes';
    var baseCache = {};

    function tidy(value) { return String(value || '').replace(/\s+/g, '').toUpperCase(); }
    function pretty(value) { var t = tidy(value); return t.length > 3 ? t.slice(0, -3) + ' ' + t.slice(-3) : t; }
    function rad(deg) { return deg * Math.PI / 180; }
    function miles(a, b) {
      var dLat = rad(b.lat - a.lat);
      var dLon = rad(b.lon - a.lon);
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return 2 * 3958.8 * Math.asin(Math.sqrt(h));
    }

    function lookupOne(pc) {
      return fetch(API + '/' + encodeURIComponent(pc)).then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('lookup failed');
        return r.json();
      }).then(function (json) {
        if (!json || !json.result) return null;
        return { lat: json.result.latitude, lon: json.result.longitude };
      });
    }

    function lookupMany(list) {
      var missing = list.filter(function (pc) { return !baseCache[pc]; });
      if (!missing.length) return Promise.resolve();
      return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ postcodes: missing }) })
        .then(function (r) { if (!r.ok) throw new Error('bulk failed'); return r.json(); })
        .then(function (json) {
          (json.result || []).forEach(function (item) {
            if (item.result) baseCache[tidy(item.query)] = { lat: item.result.latitude, lon: item.result.longitude };
          });
        });
    }

    function init(root) {
      var finder = root.querySelector('[data-pgx-dir-finder]');
      if (!finder || finder.getAttribute('data-ready')) return;
      finder.setAttribute('data-ready', '1');
      finder.hidden = false;

      var editor = document.documentElement.classList.contains('shopify-design-mode');
      var form = finder.querySelector('[data-pgx-dir-form]');
      var input = form.querySelector('input');
      var status = finder.querySelector('[data-pgx-dir-status]');
      var reset = finder.querySelector('[data-pgx-dir-reset]');
      var grid = root.querySelector('[data-pgx-dir-grid]');
      var nocover = root.querySelector('[data-pgx-dir-nocover]');
      var nocoverLink = root.querySelector('[data-pgx-dir-nocover-link]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.pgx-dir-card'));

      function say(text, state) { status.textContent = text; if (state) status.setAttribute('data-state', state); else status.removeAttribute('data-state'); }

      // Search-first: no detailers are shown until a postcode has been searched.
      function clearResults() {
        cards.forEach(function (card) {
          card.hidden = false;
          card.style.order = '';
          var d = card.querySelector('[data-pgx-dir-distance]');
          if (d) { d.hidden = true; d.textContent = ''; }
        });
        if (grid) grid.hidden = !editor;
        nocover.hidden = true;
        reset.hidden = true;
      }

      clearResults();

      reset.addEventListener('click', function () { clearResults(); say(''); input.value = ''; input.focus(); });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var code = tidy(input.value);
        if (!/^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(code)) {
          clearResults();
          say('Please enter a full UK postcode, for example TN34 1BA.', 'error');
          return;
        }
        say('Searching…');
        var bases = [];
        cards.forEach(function (card) { var pc = tidy(card.getAttribute('data-coverage-postcode')); if (pc && bases.indexOf(pc) === -1) bases.push(pc); });

        Promise.all([lookupOne(code), lookupMany(bases)]).then(function (results) {
          var origin = results[0];
          if (!origin) { clearResults(); say('We couldn’t find that postcode. Please check it and try again.', 'error'); return; }

          var matches = [];
          cards.forEach(function (card) {
            var base = baseCache[tidy(card.getAttribute('data-coverage-postcode'))];
            var radius = parseFloat(card.getAttribute('data-coverage-radius')) || 0;
            var dist = base ? miles(origin, base) : null;
            var inside = base && dist <= radius;
            card.hidden = !inside;
            var label = card.querySelector('[data-pgx-dir-distance]');
            if (inside) {
              matches.push({ card: card, dist: dist });
              if (label) { label.textContent = dist < 1 ? 'Under 1 mile away' : 'About ' + Math.round(dist) + ' miles away'; label.hidden = false; }
            } else if (label) { label.hidden = true; label.textContent = ''; }
          });

          matches.sort(function (a, b) { return a.dist - b.dist; });
          matches.forEach(function (m, i) { m.card.style.order = String(i); });
          reset.hidden = false;

          if (matches.length) {
            nocover.hidden = true;
            if (grid) { grid.classList.toggle('pgx-dir-grid--single', matches.length === 1); grid.hidden = false; }
            say(matches.length === 1 ? '1 detailer covers ' + pretty(code) : matches.length + ' detailers cover ' + pretty(code));
            if (grid && grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            if (grid) grid.hidden = !editor;
            nocover.hidden = false;
            say('No detailers cover ' + pretty(code) + ' yet.');
            var subject = encodeURIComponent('No detailer near ' + pretty(code));
            var body = encodeURIComponent('Hello Pure Gloss,\n\nI searched for a detailer near ' + pretty(code) + ' and none covered my area. Please let me know when a detailer opens near me.\n\nName:\nVehicle:\n');
            nocoverLink.setAttribute('href', 'mailto:sales@puregloss.co.uk?subject=' + subject + '&body=' + body);
          }
        }).catch(function () {
          clearResults();
          say('Postcode search is unavailable right now. Please try again in a moment, or email sales@puregloss.co.uk and we’ll point you to a detailer.', 'error');
        });
      });
    }

    function boot() { document.querySelectorAll('[data-pgx-dir-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
